import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'

//SISTEMA

import { actions as act_sistema } from './app/SISTEMA/actions.js'
import { mutations as mut_sistema } from './app/SISTEMA/mutations.js'


// SUCURSALES

import { actions as act_sucursales } from './app/SUCURSALES/actions.js'
import { mutations as mut_sucursales } from './app/SUCURSALES/mutations.js'

// INVENTARIO
import { actions as act_inventario } from './app/INVENTARIO/actions.js'
import { mutations as mut_inventario } from './app/INVENTARIO/mutations.js'

// FACTURADOR
import { actions as act_facturador } from './app/FACTURADOR/actions.js'
import { mutations as mut_facturador } from './app/FACTURADOR/mutations.js'

Vue.use(Vuex)

const vuexPersist = new VuexPersist({
    key: 'fdb',
    storage: window.localStorage,
    reducer: state => ({
        token_sesion: state.token_sesion,
        datos_usuario: state.datos_usuario,
        id_empresa_seleccionada: state.id_empresa_seleccionada,
        nombre_empresa_seleccionada: state.nombre_empresa_seleccionada
    })
})


export default new Vuex.Store({
    state: {
        token_sesion: '',
        preferencias: {
            PROTOCOLO: process.env.NODE_ENV == 'production' ? 'https' : 'http',
            DNS: process.env.NODE_ENV == 'production' ? 'https://nsafirma.com.gt/app/clickphoto' : 'http://localhost:8019',
            SOCKET: process.env.NODE_ENV == 'production' ? 'nsafirma.com.gt' : 'localhost:8019',
            IP: process.env.NODE_ENV == 'production' ? 'nsafirma.com.gt/app/clickphoto' : 'localhost:8019',
            PUERTO: 8019
        },
        datos_usuario: {},
        limpiar: false,
        loading: false,
        id_empresa_seleccionada: 0,
        nombre_empresa_seleccionada: '',
        roles: [],
        usuarios: [],
        usuario_a_editar: {},
        _socket: false,
        rutas: [
            // { api: `permisos`, set: 'set_permisos' }
        ],
        correlativos: {},
        //SUCURSALES
        sucursales: [],
        sucursal_seleccionada: {},
        filtro_sucursal_promociones: '',
        sucursal_codigo: '', // este state es para el getter que agrega el nombre de de la sucursal
        //UNIDADES
        unidades_: [],
        //MARCAS
        marcas_: [],
        //PRODUCTOS
        producto_seleccionado: {},
        lista_productos: [],
        lista_formulas: [],
        //INVENTARIO
        proveedores_: [],
        materiales: [],
        maquinas: [],
        tipos_de_rollo: [],
        item_merma: {},
        motivos_salida: [],
        vendedores: [],
        modal_buscar_productos: false,
        articulo_busqueda_seleccionado: {}, //aqui se guarda el articulo seleccionado por el modal de busqueda
        //BUSQUEDA
        objeto_busqueda: {},
        modal_cambio_precios: true,
        // MOTIVOS SALIDAS
        motivo_seleccionado: {},
        // FACTUADOR
        obj_solicitud_descuento: {},
        obj_detalle_descuento: {},
        // SOLICITUDES DE DESCUENTO
        obj_solicitudes_descuento_admon: {},
        // USUARIOS
        objeto_usuario: {
            datos_principales: {},
            datos_empresas: []
        },
        lista_usuarios_panel: [],
        usuario_seleccionado_permisos: {},
        permisos: {},
        empresas_por_usuario: [],
        filtro_productos_sucursales_traslados: '',
        motivos_entrada: [],
        datos_cliente: {},
        forma_de_pago: {},
        carrito_facturador: [],
        datos_anticipo_modal: {},
        datos_anticipo_completo: {}
    },
    getters: {
        TOKEN_FORMATEADO: state => {
            let token_formateado = {
                headers: {
                    Authorization: `Bearer ${state.token_sesion}`
                }
            }

            return token_formateado
        },
        URL_SERVIDOR: state => {
            let url = `${state.preferencias.PROTOCOLO}://${state.preferencias.IP}`
            return url
        },
        ES_ROOT: state => {
            return state.datos_usuario.parametros.roles.includes('ROOT')
        },
        ES_SUPERVISOR: state => {
            return state.datos_usuario.parametros.roles.includes('SUPERVISOR')
        },
        ES_VENDEDOR: state => {
            return state.datos_usuario.parametros.roles.includes('VENDEDOR')
        },
        QUITAR_BODEGA_CENTRAL: state => {
            if (state.datos_usuario.parametros.roles.includes('ROOT')) {
                return state.sucursales
            } else {
                return state.sucursales.filter(sucursal => sucursal.codigo !== 0);
            }
        },
        SUCURSALES_SIN_BODEGA_CENTRAL: state => {
            return state.sucursales.filter(sucursal => sucursal.codigo !== 0);
        },
        FILTRAR_PRODUCTOS_POR_SUCURSAL: state => {
            if (state.filtro_productos_sucursales_traslados === '') {
                return [];
            }
            return state.lista_productos.filter(producto =>
                producto.sucursal === state.filtro_productos_sucursales_traslados
            );
        },
        PROMOCIONES_FITLTRADAS: state => {
            if (state.filtro_sucursal_promociones === '') {
                return state.lista_formulas;
            }
            return state.lista_formulas.filter(formula =>
                formula.sucursal === state.filtro_sucursal_promociones
            );
        },
        PROMOCIONES_FILTRADAS_REPORTE: state => {
            if (state.filtro_sucursal_promociones === '') {
                return [];
            }
            return state.lista_formulas.filter(formula =>
                formula.sucursal === state.filtro_sucursal_promociones
            );
        },
        BANNER_EMPRESA: state => {
            if (!state.datos_usuario?.empresas) return ''
            let filtro = state.datos_usuario.empresas.filter(empresa => empresa.codigo_empresa === state.id_empresa_seleccionada)
            if (!filtro[0]) return ''
            return `${state.preferencias.PROTOCOLO}://${state.preferencias.IP}${filtro[0].logo}`
        },
        USER_HAS_PERMISSION: (state) => (permission) => {
            return state.datos_usuario.parametros.modulos.includes(permission)
        }
    },
    mutations: {
        ...mut_sistema,
        ...mut_sucursales,
        ...mut_inventario,
        ...mut_facturador
    },
    actions: {
        ...act_sistema,
        ...act_sucursales,
        ...act_inventario,
        ...act_facturador
    },
    plugins: [vuexPersist.plugin],
    modules: {
    }
})
